"use client";

import { useEffect } from "react";

/** Sayfa ömrü boyunca bir kez yüklenir (geliştirmede StrictMode efekti iki kez çalıştırır). */
let yuklendi = false;

/**
 * Google Analytics — GECİKMELİ yükleme.
 *
 * Eskiden @next/third-parties/google kullanılıyordu; o bileşen gtag.js'i
 * (178 KB) <head>'de yüksek öncelikle önceden yüklüyordu. Mobilde bu indirme
 * hero görseli ve yazı tipleriyle aynı yavaş hat için yarışıyor, ayrıca
 * ana iş parçacığında ~300 ms çalışıyordu — sayfa daha ekrana gelmeden.
 *
 * Artık ilk kullanıcı etkileşiminde (kaydırma, dokunma, tuş) ya da en geç
 * 5 saniye sonra yüklenir. Bedeli: hiç etkileşmeden 5 saniye içinde çıkan
 * ziyaretçi ölçülmez.
 *
 * Onay sırası korunur: onay.js window.gtag ve dataLayer'ı zaten kuruyor ve
 * 'consent default' komutunu ilk sıraya koyuyor. Buradaki 'js' ve 'config'
 * komutları kuyrukta onun ARKASINA girer; gtag.js yüklendiğinde sırayla işler.
 */
export function Analitik({ gaId }: { gaId: string }) {
  useEffect(() => {
    if (yuklendi) return;
    const olaylar = ["pointerdown", "keydown", "scroll", "touchstart"];
    let zaman = 0;

    const temizle = () => {
      window.clearTimeout(zaman);
      for (const o of olaylar) window.removeEventListener(o, yukle);
    };

    function yukle() {
      temizle();
      if (yuklendi) return;
      yuklendi = true;
      window.gtag?.("js", new Date());
      window.gtag?.("config", gaId);
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);
    }

    zaman = window.setTimeout(yukle, 5000);
    for (const o of olaylar) window.addEventListener(o, yukle, { passive: true });
    return temizle;
  }, [gaId]);

  return null;
}
